const my_profile = {
  viewMyClubSeacretProfile: "Lihat Profil ClubSeacret Saya", // translated 
  viewMoreDetails: "Lihat Butiran Lanjut", // translated 
  verifiedEmail: "E-mel Disahkan", // translated 
  unverifiedEmail: "E-mel Tidak Disahkan", // translated 
  balance: "Baki", // translated 
  pointsIn: "Mata Masuk", // translated 
  pointsOut: "Mata Keluar", // translated 
  topUp: "Tambah Nilai", // translated 
  pointsHistoryTable: "Jadual Sejarah Mata", // translated 
  createdFrom: "Dicipta Daripada", // translated 
  createdTo: "Dicipta Untuk", // translated 
  selectStatus: "Pilih status...", // translated 
  searchByTitle: "Cari mengikut tajuk...", // translated 
  offerStatus: "Status Tawaran", // translated 
  selectOfferStatus: "Semua", // translated 
  quotationSent: "Sebut Harga Dihantar", // translated 
  offerInProgress: "Tawaran Sedang Dijalankan", // translated 
  offerAvailable: "Tawaran Tersedia", // translated 
  offerAccepted: "Tawaran Diterima", // translated 
  offerExpired: "Tawaran Tamat Tempoh", // translated 
  offerReference: "Rujukan Tawaran", // translated 
  tripStartDate: "Tarikh Mula Perjalanan", // translated 
  dueDate: "Tarikh Akhir", // translated 
  viewOffer: "Lihat Tawaran", // translated 
  notApplicable: "Tidak Ada", // translated 
  manageSubscription: "Urus Langganan", // translated 
  logoAndColors: "Logo & Warna", // translated 
  editColors: "Edit Warna", // translated 
  editLogo: "Sunting Logo", // translated 
  primaryColor: "Warna Utama", // translated 
  secondaryColor: "Warna Sekunder", // translated 
  subagentLogoAlt: "Logo Subejen", // translated 
  pickColors: "Pilih Warna", // translated 
  logoPreview: "Pratonton Logo", // translated 
  logoPreviewAlt: "Pratonton logo", // translated 
  noLogoSelected: "Tiada logo dipilih", // translated 
  changeLogo: "Tukar Logo", // translated 
  uploadLogo: "Muat Naik Logo", // translated 
  supportedImageFormats: "Format yang disokong: JPG, PNG. Saiz maksimum: 2MB", // translated 
  saving: "Menyimpan...", // translated 
  logoUpdatedSuccess: "Logo berjaya dikemas kini", // translated 
  failedToUpdateLogo: "Gagal mengemas kini logo", // translated 
  colorsUpdatedSuccess: "Warna berjaya dikemas kini", // translated 
  failedToUpdateColors: "Gagal mengemas kini warna", // translated 
  selectImageFile: "Sila pilih fail imej", // translated 
  imageSizeLimit: "Saiz imej mestilah kurang daripada 5MB", // translated 
  pushNotifications: "Pemberitahuan Tolak", // translated 
  pushNotificationsDescription: "Terima pemberitahuan pelayar untuk kemas kini dan acara penting", // translated 
  pushNotificationsNotSupported: "Pemberitahuan tolak tidak disokong dalam pelayar ini", // translated 
  pushNotificationsDeniedMessage: "Kebenaran pemberitahuan telah ditolak. Sila dayakan pemberitahuan dalam tetapan pelayar anda untuk menerima pemberitahuan tolak.", // translated 
  pushNotificationsEnabled: "Pemberitahuan push berjaya didayakan", // translated 
  pushNotificationsDisabled: "Pemberitahuan push berjaya dilumpuhkan", // translated 
  userInformationMissing: "Maklumat pengguna tiada", // translated 
  failedToUpdatePushNotifications: "Gagal mengemas kini tetapan pemberitahuan tolak", // translated 
  notificationPermissionDenied: "Kebenaran pemberitahuan telah ditolak. Sila dayakannya dalam tetapan pelayar anda.", // translated 
  notificationPermissionRequired: "Kebenaran pemberitahuan diperlukan untuk mendayakan pemberitahuan tolak", // translated 
  notSupported: "Tidak disokong", // translated 
  permissionDenied: "Kebenaran ditolak", // translated 
  permissionNotRequested: "Kebenaran tidak diminta", // translated 
  enabled: "Didayakan", // translated 
  disabled: "Orang Kurang Upaya", // translated 
};






export default my_profile;
